module.exports = __webpack_public_path__ + "media/application/images/fractured-background-d44e8e36af06b51f8fe320b30369352b.png";